export default __webpack_public_path__ + "bd67564ba49a9b4944f1ac5c812adc9d.png";